export const m = (path: string, params?: Record<string, unknown>) =>
  JSON.stringify({ path, ...params })
